import React from "react";
import { useNavigate } from "react-router-dom";
import Today from "../Today/Today";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";

import "./jobCard.css";

export default function JobCard({ job, handleShowJobDetails }) {
  let closeOutButton;
  if (job.is_today) {
    closeOutButton = {
      backgroundColor: "#0C3330",
    };
  } else {
    closeOutButton = {
      backgroundColor: "#C6C6C6",
    };
  }

  const navigate = useNavigate();

  const handleProceedInstallerPack = () => {
    navigate(`/jobs/${job.kouid}/${job.lsui}`);
  };

  return (
    <div className="job-card-wrapper mt-3">
      <div className="job-card container mb-5 py-3">
        <header className="row">
          <div className="col">
            <h5 className="text-left font-weight-normal">{job.name}</h5>
          </div>
          {job.is_today && (
            <div className="col text-right">
              <Today />
            </div>
          )}
        </header>
        <hr className="mt-1" />
        <section>
          <div className="d-flex justify-content-start align-items-start mb-3">
            <i className="icon icon-house-energy text-jungle-green"></i>
            <span className="ml-2 text-left">{job.address}</span>
            <CopyToClipboard textToCopy={job.postcode} />
          </div>
          <p className="d-flex justify-content-start align-items-center mb-3">
            <i className="icon icon-phone text-jungle-green"></i>
            <a href={`tel:${job.phone}`} className="font-weight-normal">
              <span className="ml-2">{job.phone}</span>
            </a>
          </p>
          <p className="d-flex justify-content-start align-items-center mb-3">
            <i className="icon icon-truck-tick text-jungle-green"></i>
            <span className="ml-2 font-weight-bold">{job.travel_time}</span>
          </p>
        </section>
        <footer>
          <div className="row justify-content-center">
            <div className="col-6">
              <button
                type="button"
                className="btn btn-cta btn-block btn-lg text-small"
                onClick={handleProceedInstallerPack}
              >
                Installer Pack
              </button>
              <button
                onClick={() => handleShowJobDetails(job)}
                type="button"
                className="job-details-button btn btn-block btn-lg text-small font-weight-normal d-none"
              >
                Job Details
                <i className="fas fa-chevron-right ml-2"></i>
              </button>
            </div>
            <div className="col-6">
              <a href={job.is_today ? job.closeout_process_link : null}>
                <button
                  type="button"
                  className="close-out-button btn btn-block btn-lg text-small text-white"
                  style={closeOutButton}
                >
                  Close Out
                  <i className="fas fa-chevron-right ml-2"></i>
                </button>
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
